// clientAdapter.js — in-memory sort + pagination for DataTable's client mode.
// Mirrors the shape serverAdapter.parseResponse produces, but no fetch: the host
// passes an already-filtered array (the page's tabs/pills do the filtering).

// Marker adapter. In client mode useTableData ignores endpoint/buildFormData and
// slices the array passed via the `clientRows` prop instead.
export function makeClientAdapter() {
   return { mode: "client" };
}

// Pure: sort `rows` by the active column (honoring an optional per-column
// `sortAccessor`), then return the requested page. Nulls sort last. pageIndex is
// clamped into range so a shrinking dataset can't strand the view on an empty page.
export function sliceClientRows({ rows, sort, columns = [], pageIndex = 0, pageSize = 10 }) {
   const all = Array.isArray(rows) ? rows : [];
   let sorted = all;
   if (sort && sort.field) {
      const col = columns.find((c) => c.field === sort.field);
      const accessor = (col && col.sortAccessor) || ((row) => row[sort.field]);
      const dir = sort.dir === "desc" ? -1 : 1;
      sorted = [...all].sort((a, b) => {
         const va = accessor(a);
         const vb = accessor(b);
         if (va == null && vb == null) return 0;
         if (va == null) return 1;   // nulls last regardless of direction
         if (vb == null) return -1;
         if (va < vb) return -1 * dir;
         if (va > vb) return 1 * dir;
         return 0;
      });
   }
   const totalRows = sorted.length;
   const size = pageSize || 10;
   const totalPages = Math.max(1, Math.ceil(totalRows / size));
   const safeIndex = Math.min(Math.max(0, pageIndex), totalPages - 1);
   const start = safeIndex * size;
   const pageRows = sorted.slice(start, start + size);
   return { pageRows, totalRows, totalPages, pageIndex: safeIndex };
}
